import { List, Stack } from '@mui/material';
import React from 'react';

type PropTypes = {
  cutoff?: number;
  onUsernameClick?: (profileId: string) => void;
  openBottomDrawer?: boolean;
  profileId: string;
};

export const TournamentStaticLeaderboard = ({
  openBottomDrawer,
}: PropTypes) => {
  return (
    <Stack
      height={openBottomDrawer ? 'calc(100% - 380px)' : '100%'}
      overflow={'auto'}
    >
      <List dense={true}>
      </List>
    </Stack>
  );
};
